export enum SelectPreferenceResponses {
  DEFAULT,
  BACK,
  EMAIL,
  PHONE,
  LIMIT,
}
